/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { globalContext } from 'contexts/globalContext';
import ContentTypography from 'components/Common/ContentTypography';
import API from 'api';
import { useHistory } from 'react-router-dom';
import FormField from 'components/pages/SignIn/Widgets/FormField';
import HideableContainer from 'components/Common/HideableContainer';
import LoginRadio from 'components/pages/SignIn/Widgets/LoginRadio';
import ClickableDiv from 'components/Common/ClickableDiv';
// import Checkbox from 'components/Common/Checkbox';
import EmailField from 'components/pages/SignIn/Widgets/EmailField';
import PasswordField from 'components/pages/SignIn/Widgets/PasswordField';
import PhoneNumberField from 'components/pages/SignIn/Widgets/PhoneNumberField';
import Steps from '../steps';
import Styles from './index.module.css';

export default function MainForm({ step, onChangeStep }) {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const { state, dispatch } = useContext(globalContext);
  // const [rememberPassword, setRememberPassword] = useState(true);

  const validate = () => true;

  const register = async () => {
    const result = await API.auth.postUserRegister(email, name, phone, password);
    if (result.error && result.error.errorMsg !== 'Auth Register User Exsisted But Not Verified') {
      alert(result.error.errorMsg);
      return result.error;
    }
    onChangeStep(Steps.ActivateAccount);
    return result.error?.errorMsg ?? null;
  };

  const login = async () => {
    const result = await API.auth.postUserLogin(email, password, '');
    if (result.error) {
      if (result.error.errorMsg !== 'Auth Login User Exsisted But Not Verified') {
        alert(result.error.errorMsg);
        return result.error;
      }
      onChangeStep(Steps.ActivateAccount);
      return null;
    }
    localStorage.setItem('access_Token', `Bearer ${result.resultData.access_Token}`);
    localStorage.setItem('userId', result.resultData.id);
    localStorage.setItem('studio', `${result.resultData.iFrameCode}`);
    localStorage.setItem('amounts', JSON.stringify({ google: result.resultData.googleAmount, facebook: result.resultData.facebookAmount }));
    dispatch({ type: 'SET_AMOUNT', payload: { google: result.resultData.googleAmount, facebook: result.resultData.facebookAmount } });
    API.axiosInstance.defaults.headers.common.Authorization = localStorage.getItem('access_Token');
    history.push({
      pathname: '/MyAds',
      state: {
        google: result.resultData.googleAmount,
        facebook: result.resultData.facebookAmount,
      },
    });
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (step === Steps.Register) {
      const error = await register();
      if (error) return null;
    }

    return login(e);
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.title}>註冊 / 登入</div>
      <form id="loginForm" onSubmit={handleSubmit}>
        <LoginRadio style={{ marginBottom: 30 }} step={step} onChangeStep={onChangeStep} />
        <EmailField
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <PasswordField
          autoComplete={step === Steps.Register ? 'new-password' : 'current-password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <HideableContainer hidden={step !== Steps.Register}>
          <label htmlFor="registration-confirm-password" className={Styles.inputLabel}>
            <ContentTypography>密碼確認</ContentTypography>
          </label>
          <div className={Styles.inputField}>
            <FormField
              id="registration-confirm-password"
              type="password"
              style={{ fontSize: 24 }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="confirm-new-password"
            />
          </div>
        </HideableContainer>
        <HideableContainer hidden={step !== Steps.Register}>
          <label htmlFor="registration-name" className={Styles.inputLabel}>
            <ContentTypography>姓名</ContentTypography>
          </label>
          <div className={Styles.inputField}>
            <FormField
              id="registration-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </HideableContainer>
        <HideableContainer hidden={step !== Steps.Register}>
          <PhoneNumberField
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </HideableContainer>
        <HideableContainer hidden={step !== Steps.Login}>
          <div className={Styles.credentialOptions}>
            {/* <div className={Styles.rememberPassword}>
              <Checkbox value={rememberPassword}
              onChange={setRememberPassword} id="remember-password" type="checkbox" />
              <div style={{ userSelect: 'none', marginLeft: 18, color: '#9A9A9A' }}>記住我的帳號密碼</div>
            </div> */}
            <ClickableDiv
              className={Styles.forgotPassword}
              onClick={() => onChangeStep(Steps.ForgotPassword)}
            >
              忘記密碼?
            </ClickableDiv>
          </div>
        </HideableContainer>
        <div>
          <button
            disabled={!validate()}
            type="submit"
            className={Styles.orangeButton}
          >
            {step === Steps.Register && '註冊'}
            {step === Steps.Login && '登入'}
          </button>
        </div>
      </form>
    </div>
  );
}

MainForm.propTypes = {
  step: PropTypes.string,
  onChangeStep: PropTypes.func,
};

MainForm.defaultProps = {
  step: '',
  onChangeStep: () => { },
};
